export const DefaultAppStyle = "material";
